const configModel = {
  // * 配置显示在浏览器标签的title
  TITLE: '门店管理',

  // * cookie key 值
  COOKIE_KEY: 'zbvz_userid',

  // * token 令牌前缀
  TOKEN_PREFIX: 'Bearer',

  // * token key 值
  TOKEN_KEY: 'vzan_store_authorization',

  // * userInfo key值
  USER_INFO_KEY: 'vzan_store_user_info',

  // * storeInfo key值
  STORE_INFO_KEY: 'vzan_store_user_store_info',

  // * zbid key值
  ZBID_KEY: 'vzan_store_zbid',

  // * lianUserId key值
  LIAN_USER_KEY: 'lian_user_id',

  // * recruitmentDirector 长期链接key
  DIRECTOR_KEY: 'Z7fsR+kFXgz5wZ3T',

  // * 路由模式
  MODE: 'history',

  // * $route.meta 大健康门店系统 key值
  ROUTE_META_KEY: 'vznaStore',

  // * cookie 存储天数
  COOKIE_EXPIRES: 1,

  // * cdn地址
  CDN_PATH: 'https://static2.sinsam.com',

  // * 路由前缀
  ROUTER_PATH: '/m/store/',

  // * 门店系统 样式变量
  STYLE_MODEL: {
    primary_color: '#ff6a00',
  },

  // * id name key值
  // * 大健康 java接口专用
  STORE_ID_KEY: {
    0: 'storeId',
    1: 'regionId',
    2: 'companyId',
  },

  STORE_AGENT_KEY: {
    0: 'agentIds',
    1: 'storeIds',
    2: 'regionIds',
  },

  STORE_CHILD_KEY: {
    1: 'selfTakeStoreId',
    2: 'storeRegionId',
  },

  // * .net 接口专用
  STORE_ID_KEY_NET: {
    0: 'storeId',
    1: 'storeRegionId',
    2: 'storeCompanyId',
  },

  // * 来源枚举
  STORE_SOURCE: {
    0: 4,
    1: 5,
    2: 6,
  },

  // * 角色枚举
  STORE_ROLE_TYPE: {
    0: 6,
    1: 8,
    2: 9,
  },

  // * 角色枚举_2
  STORE_DROLE_TYPE: {
    0: 3,
    1: 5,
    2: 6,
  },

  STORE_BUS_TYPE: {
    0: 6,
    1: 8,
    2: 9,
  },

  STORE_FORM: {
    0: 4,
    1: 5,
    2: 6,
  },

  PRIMARY_COLORS: {
    0: 'rgba(255, 106, 0, 1)',
    1: 'rgba(77, 69, 227, 1)',
    2: 'rgba(255, 58, 82, 1)',
  },

  // 权限接口标识
  ROLECODE_MAP: {
    0: 'store_account',
    1: 'region_account',
    2: 'company_account',
  },
}

export default configModel
